import ChargerModule from 'components/chargerModule';
import UploadCatalogModule from './UploadCatalogModule';
import './UploadCatalog.scss';

const UploadCatalog = () => {
  return (
    <ChargerModule
      headerInfo={{
        title: 'Cargue Masivo',
        subtitle: '',
        titleRoute: '/bulk-upload/type-of-charge'
      }}
      infoSideBar={{ position: 'bulkUpload' }}
    >
      <UploadCatalogModule />
    </ChargerModule>
  );
};

export default UploadCatalog;
